import { Store } from '@ngrx/store';

import { SidebarPortInterface, SidebarPublicPort } from '@features/sidebar';

export const SidebarAdapter: SidebarPortInterface = {
    openSidebar: (
        store: Store,
        saveDoneCallback: (success: boolean) => void = () => {},
    ) => {
        SidebarPublicPort(store).openSidebarCustom({
            // eslint-disable-next-line no-secrets/no-secrets
            component: 'UpdateOrderDeliveryAddressFormComponent' as any,
            initializeFunction: undefined,
            data: {
                saveDoneCallback,
            },
        });
    },
    closeSidebar: (store: Store) => {
        SidebarPublicPort(store).closeSidebar();
    },
};
